export class UpdateDonationExperienceModel {
  wall_images: string;
  is_donor_experience: boolean;

  constructor(obj?: any) {
    if (obj) {
      Object.keys(this).forEach((key) => {
        if (obj.hasOwnProperty(key)) {
          this[key] = obj[key];
        }
      });
    }
  }
}
